import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import DivLoader from "components/divloader/DivLoader";
import { useEffect, useState } from "react";
import { MdDelete, MdHighlightOff } from "react-icons/md";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";

const DeleteModal = ({
  name, id, fetchKycVelocity, heading, infoData, message, handleDelete,
}: {
  name: string; id: string; fetchKycVelocity: () => void;
  heading: string; message: string; handleDelete: any; infoData?: any;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState<boolean>();
  const [isCloseModal, setIsCloseModal] = useState<boolean>(false);
  const [record, setRecord] = useState<any>({});
  const [popoverOpen, setPopoverOpen] = useState(false);

  useEffect(() => { setRecord(infoData?.row?.original ?? {}); }, [infoData]);

  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  return (
    <>
      <Popover trigger="hover" placement="bottom" closeOnBlur  closeOnEsc isOpen={popoverOpen && !isOpen} onOpen={() => setPopoverOpen(true)} onClose={() => setPopoverOpen(false)}>
        <PopoverTrigger>
          <button className="kycd-del-trigger" onClick={onOpen} aria-label="Delete" onMouseEnter={() => !isOpen && setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}>
            <MdDelete size={15} />
          </button>
        </PopoverTrigger>
        <PopoverContent border="1px solid #fecaca" borderRadius="12px" bg="#fff1f2" maxW="160px" p="0" overflow="hidden" zIndex="20">
          <PopoverHeader bg="#ffe4e6" fontSize="12px" fontWeight="700" color="#b91c1c" borderBottom="1px solid #fecaca" px="12px" py="9px">Delete Velocity</PopoverHeader>
          <PopoverArrow bg="#fff1f2" />
        </PopoverContent>
      </Popover>

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`kycd-panel${isOpen && !isCloseModal ? " kycd-panel--open" : " kycd-panel--close"}`}>
          <div className="kycd-glow" />
          <div className="kycd-header">
            <div className="kycd-header-brand">
              <div className="kycd-header-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
                  <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                </svg>
              </div>
              <div>
                <h2 className="kycd-title">Delete Velocity Rule</h2>
                <p className="kycd-sub">This action is irreversible</p>
              </div>
            </div>
            <button className="kycd-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="kycd-body">
            <div className="kycd-warning">
              <div className="kycd-warning-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </div>
              <div>
                <p className="kycd-warning-title">Irreversible Action</p>
                <p className="kycd-warning-desc">{message || "This KYC velocity rule will be permanently deleted."}</p>
              </div>
            </div>

            {record?.country && (
              <div className="kycd-record-card">
                <p className="kycd-record-label">Rule to be deleted</p>
                <div className="kycd-record-row">
                  <span className="kycd-record-key">Country</span>
                  <span className="kycd-record-val">{record.country}</span>
                </div>
              </div>
            )}
          </div>

          <div className="kycd-footer">
            <button className="kycd-btn-cancel" onClick={handleClose}>Cancel</button>
            <button className="kycd-btn-delete" disabled={!!isLoading}
              onClick={() => { setIsLoading(true); handleDelete(id); }}
            >
              {isLoading ? <span className="kycd-spinner" /> : (
                <><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/></svg>Delete Rule</>
              )}
            </button>
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .kycd-del-trigger { width:30px; height:30px; border-radius:8px; background:#fff7f7; border:1.5px solid #fecaca; color:#dc2626; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:all .15s; }
        .kycd-del-trigger:hover { background:#fee2e2; }
        .kycd-panel { font-family:'Plus Jakarta Sans',sans-serif; position:fixed; top:0; right:0; bottom:0; width:100%; max-width:520px; background:#fff; z-index:1004; display:flex; flex-direction:column; box-shadow:-12px 0 60px rgba(15,23,42,.18); transition:transform .35s cubic-bezier(0.16,1,0.3,1); overflow:hidden; }
        .kycd-panel--open  { transform:translateX(0); }
        .kycd-panel--close { transform:translateX(100%); }
        .kycd-glow { height:3px; flex-shrink:0; background:linear-gradient(90deg,#7f1d1d,#dc2626,#ef4444,#dc2626,#7f1d1d); background-size:200% 100%; animation:kycdGlow 3s linear infinite; }
        @keyframes kycdGlow { 0%{background-position:0%} 100%{background-position:200%} }
        .kycd-header { padding:15px 26px; background:linear-gradient(135deg,#7f1d1d 0%,#b91c1c 60%,#dc2626 100%); display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
        .kycd-header-brand { display:flex; align-items:center; gap:13px; }
        .kycd-header-icon { width:42px; height:42px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .kycd-title { font-size:16px; font-weight:800; color:#fff; letter-spacing:-.3px; margin-bottom:2px; line-height:1; }
        .kycd-sub { font-size:12px; color:rgba(255,255,255,.55); font-weight:500; }
        .kycd-close { background:none; border:none; cursor:pointer; color:rgba(255,255,255,.65); display:flex; align-items:center; transition:color .15s; }
        .kycd-close:hover { color:#fff; }
        .kycd-body { flex:1; padding:24px 26px; display:flex; flex-direction:column; gap:16px; }
        .kycd-warning { display:flex; gap:14px; background:linear-gradient(135deg,#fff7f7,#fee2e2); border:1.5px solid #fecaca; border-radius:13px; padding:16px 18px; }
        .kycd-warning-icon { width:44px; height:44px; border-radius:11px; background:#fff; border:1.5px solid #fecaca; display:flex; align-items:center; justify-content:center; color:#dc2626; flex-shrink:0; }
        .kycd-warning-title { font-size:14px; font-weight:700; color:#991b1b; margin-bottom:5px; }
        .kycd-warning-desc { font-size:13px; color:#b91c1c; font-weight:500; line-height:1.5; }
        .kycd-record-card { background:#f8fafc; border:1.5px solid #e2e8f0; border-radius:13px; overflow:hidden; }
        .kycd-record-label { padding:10px 16px 8px; font-size:11px; font-weight:800; color:#94a3b8; text-transform:uppercase; letter-spacing:0.7px; border-bottom:1px solid #f1f5f9; }
        .kycd-record-row { display:flex; align-items:center; justify-content:space-between; padding:11px 16px; }
        .kycd-record-key { font-size:12px; font-weight:700; color:#94a3b8; }
        .kycd-record-val { font-size:13px; font-weight:700; color:#0f172a; }
        .kycd-footer { padding:14px 26px; border-top:1.5px solid #f1f5f9; background:#fafbfc; display:flex; align-items:center; justify-content:flex-end; gap:10px; flex-shrink:0; }
        .kycd-btn-cancel { font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:600; color:#64748b; padding:9px 16px; border-radius:10px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
        .kycd-btn-cancel:hover { background:#f1f5f9; }
        .kycd-btn-delete { display:inline-flex; align-items:center; gap:7px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; font-weight:700; color:#fff; padding:10px 18px; border-radius:10px; border:none; background:linear-gradient(135deg,#991b1b,#dc2626); cursor:pointer; box-shadow:0 4px 14px rgba(220,38,38,.28); transition:all .15s; }
        .kycd-btn-delete:hover { transform:translateY(-1px); box-shadow:0 8px 24px rgba(220,38,38,.36); }
        .kycd-btn-delete:disabled { opacity:.5; cursor:not-allowed; transform:none; }
        .kycd-spinner { display:inline-block; width:14px; height:14px; border:2px solid rgba(255,255,255,.35); border-top-color:#fff; border-radius:50%; animation:kycdSpin .65s linear infinite; }
        @keyframes kycdSpin { to{transform:rotate(360deg)} }
        @media (max-width:640px) { .kycd-panel { max-width:100%; } }
      `}</style>
    </>
  );
};

export default DeleteModal;